import { render, staticRenderFns } from "./WiringsHeadersList.vue?vue&type=template&id=1edf4401&scoped=true"
import script from "./WiringsHeadersList.vue?vue&type=script&lang=js"
export * from "./WiringsHeadersList.vue?vue&type=script&lang=js"
import style0 from "./WiringsHeadersList.vue?vue&type=style&index=0&id=1edf4401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf4401",
  null
  
)

export default component.exports